export default {
    betaWarning: 'Auto-generate a diet plan',
    days: 'Which days would you like to generate? (existing contents will be deleted)',
    enableAll: 'Enable all',
    disableAll: 'Disable all',
    calories: 'How many calories?',
    sameDinner: 'Use the same lunch/dinner?',
    sameDinner2: 'always selects lunch as the meal template category',
    calorieDistribution: 'How would like to distribute the calories across the meals? (Type 0 to ignore a meal)',
    intro: '<p>\n' +
        '        Auto-generation builds the plan from your own meal templates. For the best results, make your templates\n' +
        '        well balanced, both in food combinations and in macronutrient split.\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        Amounts are rounded to steps that are easy to measure (e.g. 5 or 10 grams, ¼ cup, ½ spoon). Eggs, bread\n' +
        '        slices and anything counted in pieces stay whole where possible, while fruit may be halved. Low-calorie\n' +
        '        vegetables and condiments usually keep the template\'s amount.\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        The system is here to help you work faster, not to replace you.\n' +
        '        <strong>Please review the plan and its choices before giving it to a client.</strong>\n' +
        '      </p>\n' +
        '      <p>\n' +
        '        <strong>Auto-generation can\'t work without meal templates.</strong>\n' +
        '      </p>',
}